<script lang="ts" setup>
import { shallowRef } from 'vue'
import { reportError } from '@/utils/error-reporter'

const props = defineProps<{
  icon: string
}>()

const svgComponent = shallowRef('')
import(`@/assets/svg/${props.icon}.svg`)
  .then((module) => {
    svgComponent.value = module.default
  })
  .catch((error) => {
    reportError(error, {
      severity: 'info',
      context: 'util-icon:loader',
      metadata: { section: 'utilIcon', values: { icon: props.icon } }
    })
  })
</script>

<template>
  <img :src="svgComponent" />
</template>

<style scoped>
img {
  width: 20px;
}
</style>
